import * as React from "react";

import { ILanguage } from "../../../common/interfaces";
import MessageSegmentPreview from "../MessageSegmentPreview/MessageSegmentPreview";
import { TextareaAutosize } from "@material-ui/core";
import { primaryBorder } from "../../../common/sharedStyle";
import { useGetComponentStringsContext } from "../../../hooks/useGetComponentStrings";

export interface LanguageMessagePreviewProps {
	language: ILanguage;
	message: string;
	onMessageChanged: (message: string) => void;
	isReadOnly: boolean;
	rowIndex: string;
	country: string;
	setShowBadVariableWarning: (show: boolean) => void;
}

export const LanguageMessagePreview: React.FC<LanguageMessagePreviewProps> = ({
	language,
	message,
	onMessageChanged,
	isReadOnly,
	rowIndex,
	country,
	setShowBadVariableWarning,
}) => {
	const strings = useGetComponentStringsContext().MessageLanguageConfiguration;

	const [messageInputFocus, setMessageInputFocus] = React.useState(false);
	const onFocus = () => {
		setMessageInputFocus(true);
	};

	const onBlur = () => {
		setMessageInputFocus(false);
	};

	const textareaAutosize = (
		<TextareaAutosize
			data-testid="messagePreview"
			rowsMin={4}
			value={message}
			className={
				"message " +
				" " +
				(!isReadOnly ? (!message ? " errorClass " : primaryBorder) : "")
			}
			onChange={(e) => onMessageChanged(e.target.value)}
			id={`message` + rowIndex + language.code}
			placeholder={`${strings.messageContentText} ` + language.name}
			style={{
				textAlign:
					language.direction.toLowerCase() === "rtl" ? "right" : "left",
			}}
			disabled={isReadOnly}
			onBlur={() => onBlur()}
			onFocus={() => onFocus()}
		/>
	);

	return (
		<>
			{textareaAutosize}
			<br />
			<MessageSegmentPreview
				messageContent={message}
				language={language}
				index={rowIndex + language.code}
				textDirection={language.direction.toLowerCase() === "rtl" ? "rtl" : ""}
				messageInputFocus={messageInputFocus}
				country={country}
				setShowBadVariableWarning={setShowBadVariableWarning}
			/>
		</>
	);
};
